import React from 'react';
import iconMap from '../../assets/svg/national.svg';

const national = (props) => {
  return (
    <section id='national' className='divide p60'>
      <div className='wrap'>
        <h2>Quality from coast to coast.</h2>
        <h4>Nothing but the best for people on the go.</h4>
        <img src={iconMap} alt='National Map' />
        <p>You’ll have access to <strong>more than 1,000,000 doctors and hospitals</strong> around the country.</p>
      </div>
    </section>
  );
};

export default national;



// WEBPACK FOOTER //
// ./src/components/National/National.js